import React from "react";
import "../css/dashboard.css";
import Navbar from "../component/Navbar";
import { IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import ClientsContentMobile from "./ClientsContentMobile";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import ExportContent from "./ExportContent";

export default function Export() {
  const navigate = useNavigate();

  const handleMenuOpen = () => {
    navigate("/menumobile");
  };

  const isMobile = useMediaQuery({ query: "(max-width: 800px)" });

  return (
    <div className="main-container">
      {isMobile ? (
        <>
          <div className="menu-button-container">
            <IconButton
              edge="start"
              color="inherit"
              aria-label="menu"
              onClick={handleMenuOpen}
              className="menu-button"
            >
              <MenuIcon />
            </IconButton>
          </div>

          <ClientsContentMobile />
        </>
      ) : (
        <>
          <Navbar linkActive={9} />
          <ExportContent />
        </>
      )}
    </div>
  );
}
